import * as React from "react"

const SvgLineChart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20.8 9.971a1 1 0 0 1-.2 1.4l-5.333 4a1 1 0 0 1-1.2 0l-4.734-3.55-4.733 3.55a1 1 0 1 1-1.2-1.6l5.333-4a1 1 0 0 1 1.2 0l4.734 3.55 4.733-3.55a1 1 0 0 1 1.4.2" />
  </svg>
)
export default SvgLineChart
